export default __webpack_public_path__ + "static/media/signage.55e8007b.svg";